import { BaseModel, HasId } from '@app/shared/models/base';
import { DisplayName } from '@app/shared/components/select/base-select-with-id.component';

export class CodeValue extends BaseModel implements HasId, DisplayName {
    public code: string;
    public value: string;
    public displayName: string;
    public sortOrder?: number;

    constructor(json?: any) {
        super(json);
    }

    get id() {
        return this.code;
    }
}
